import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'baseline-density-large', 'BaselineDensityLarge', [["path",{"d":"M4 4h16"}],["path",{"d":"M4 20h16"}]]);